module.exports = __webpack_public_path__ + "static/energy_4-5bedebadedc221e50e40b719d1df88b9.jpg";